/**
 * Déplacement d'un programme dans l'ordre d'une collection.
 *
 * Isolé du composant pour être éprouvé seul : l'API exige une permutation
 * exacte du contenu, et c'est ici que se garantit qu'un déplacement ne perd ni
 * ne duplique une fiche.
 */

/**
 * Déplace `programId` d'un cran dans `orderedIds`.
 *
 * Rend le nouvel ordre, ou `null` quand le déplacement n'a pas lieu d'être —
 * fiche absente, ou déjà à l'extrémité. Rendre `null` plutôt qu'une copie
 * identique évite un aller-retour réseau qui n'écrirait rien.
 */
export function moveInOrder(
  orderedIds: string[],
  programId: string,
  direction: -1 | 1,
): string[] | null {
  const index = orderedIds.indexOf(programId)
  if (index < 0) return null

  const target = index + direction
  if (target < 0 || target >= orderedIds.length) return null

  const next = [...orderedIds]
  // Échange plutôt que retrait/insertion : un déplacement d'un cran ne doit
  // décaler que deux positions, jamais renuméroter toute la liste.
  ;[next[index], next[target]] = [next[target], next[index]]
  return next
}
